interface Images {
  LOGO: string;
  NAVBAR_VERTRAG: string;
  NAVBAR_UBERSICHT: string;
  FILES: string;
  CLOSE: string;
  UPLOAD: string;
  ATTENTION: string;
  VALIDATE: string;
  ERROR: string;
  SUCCESS: string;
  WARNING: string;
  FOLDER: string;
  DOCUMENT: string;
  CONTRACT: string;
  COMPANY: string;
  STRUCTURE_VALIDATION: string;
  NOMENCLATURE_VALIDATION: string;
  SIZE_QUANTITY_VALIDATION: string;
  DUPLICATE_DETECTION: string;
  METADATA_VALIDATION: string;
  SWAP: string;
  POLYGON: string;
  EDIT: string;
  DELETE: string;
  DOWNLOAD: string;
  LOGO_DARK: string;
  LOGO_WHITE: string;
  MACROS_LOGO_WHITE: string;
}

export const IMAGES: Images = {
  LOGO: '/assets/dorasmartcheck_logo_final.svg',
  LOGO_WHITE: '/assets/dorasmartcheck_logo_white.png',
  MACROS_LOGO_WHITE: '/assets/macros_logo_white.png',
  NAVBAR_VERTRAG: '/assets/navbar_vertrag.svg',
  NAVBAR_UBERSICHT: '/assets/navbar_ubersicht.svg',
  FILES: '/assets/files.svg',
  CLOSE: '/assets/close.svg',
  UPLOAD: '/assets/upload.svg',
  ATTENTION: '/assets/attention.svg',
  VALIDATE: '/assets/validate.svg',
  ERROR: '/assets/error-icon.png',
  SUCCESS: '/assets/success-icon.png',
  WARNING: '/assets/warning-icon.png',
  FOLDER: '/assets/folder-icon.png',
  DOCUMENT: '/assets/document-icon.png',
  CONTRACT: '/assets/contract-icon.png',
  COMPANY: '/assets/company-icon.png',
  STRUCTURE_VALIDATION: '/assets/01_structure_validation.svg',
  NOMENCLATURE_VALIDATION: '/assets/02_nomenclature_validation.svg',
  SIZE_QUANTITY_VALIDATION: '/assets/03_size_quantity_validation.svg',
  DUPLICATE_DETECTION: '/assets/04_duplicate_detection.svg',
  METADATA_VALIDATION: '/assets/05_metadata_validation.svg',
  SWAP: '/assets/swap.svg',
  POLYGON: '/assets/polygon.svg',
  EDIT: '/assets/edit.svg',
  DELETE: '/assets/delete.svg',
  DOWNLOAD: '/assets/download.svg',
  LOGO_DARK: '/assets/dorasmartcheck_logo_dark.svg',
};
